import * as React from 'react';
import Project from 'src/entities/Project';
import QuarterlyReportMiniatureContainer
  from 'src/modules/project/partials/quarterly-reports/QuarterlyReportMiniature.container';

interface Props {
  project: Project;
}

const QuarterlyReportsComponent: React.StatelessComponent<Props> = (props: Props) => (
  <div className="col-sm-9">
    <div className="padding-left-30">
      <div className="gap-50"/>

      <h3>
        Informes de seguimiento
      </h3>
      <div className="gap-20"/>
      <div className="row">
        {props.project.company.quarterlyReports ?
          props.project.company.quarterlyReports.map((quarterlyReport) => (
            <div
              className="col-md-6 padding-20"
              key={quarterlyReport.id}
            >
              <QuarterlyReportMiniatureContainer quarterlyReport={quarterlyReport}/>
            </div>
          )) : null
        }
      </div>
      <div className="gap-30"/>
        <p className="question-detail">
          (Es posible que para poder descargar los documentos tengas que desactivar tu bloqueador de publicidad.)
        </p>
      <div className="gap-20"/>
    </div>
  </div>
);

export default QuarterlyReportsComponent;



// WEBPACK FOOTER //
// ./src/modules/project/partials/quarterly-reports/QuarterlyReports.component.tsx